export class GooruSearchSerializer {

  private static INSTANCE = new GooruSearchSerializer();

  static get instance() {
    return this.INSTANCE;
  }

  public normalizeSearchCoursesBySubject(payload: any) {
    return payload && payload.searchResults ? payload : [];
  }

}

export const gooruSearchAPISerializer = GooruSearchSerializer.instance;
